<div class="LandingPage-content flex u-spacing-2xl-pt flex-middle">
    <div class="LandingPage-container flex flex-top u-border-radius-md u-color-background-primary u-spacing-2xl-pa">
        <form
            [formGroup]="receiptForm"
            (ngSubmit)="onSubmit()"
            class="LandingPage-form-section flex flex-middle"
            novalidate
        >
            <!-- Title and Lead Text -->
            <div class="LandingPage-title-section flex">
                <h1 class="u-text-title-lg">Find your charging receipt</h1>
                <div class="LandingPage-description u-text-body-sm u-color-text-secondary">
                    You can only get a receipt if you paid for charging through the payment terminal.
                </div>
            </div>

            <!-- Form Section -->
            <fieldset
                class="LandingPage-form flex flex-top"
                aria-labelledby="form-title"
                style="border: none; padding: 0"
            >
                <!-- Charging Date Field -->
                <div class="LandingPage-form-field">
                    <ce-form-field>
                        <label ce-input-label for="chargingDate" class="u-text-label-sm">
                            Charging date (DD/MM/YYYY)
                        </label>
                        <input
                            ce-input
                            required
                            id="chargingDate"
                            type="text"
                            [formControl]="chargingDateControl"
                            placeholder="DD/MM/YYYY"
                            class="LandingPage-form-input flex u-size-xl-h disabled:u-color-background-primary"
                        />

                        @if (chargingDateControl.errors?.['required']) {
                            <span ce-input-error>cannot be empty</span>
                        } @else if (chargingDateControl.errors?.['invalidFormat']) {
                            <span ce-input-error>use DD/MM/YYYY format</span>
                        } @else if (chargingDateControl.errors?.['invalidDate']) {
                            <span ce-input-error>enter a real date</span>
                        } @else if (chargingDateControl.errors?.['futureDate']) {
                            <span ce-input-error>cannot be in the future</span>
                        } @else if (chargingDateControl.errors?.['exceededOneYear']) {
                            <span ce-input-error>cannot be older than 12 months</span>
                        }
                    </ce-form-field>
                </div>

                <!-- Payment Card Field -->
                <div class="LandingPage-form-helper">
                    <ce-form-field class="LandingPage-form-field">
                        <label ce-input-label for="paymentCardLastFourDigits" class="u-text-label-sm"
                            >Card 4 last digits</label
                        >
                        <input
                            ce-input
                            required
                            id="paymentCardLastFourDigits"
                            type="text"
                            pattern="[0-9]{4}"
                            maxlength="4"
                            inputmode="numeric"
                            [formControl]="paymentCardLastFourDigitsControl"
                            placeholder="XXXX"
                            class="LandingPage-form-input flex u-size-xl-h disabled:u-color-background-primary"
                        />

                        @if (paymentCardLastFourDigitsControl.errors?.['required']) {
                            <span ce-input-error>cannot be empty</span>
                        } @else if (paymentCardLastFourDigitsControl.errors?.['pattern']) {
                            <span ce-input-error>enter exactly 4 digits</span>
                        }

                        <span ce-input-hint-persistent
                            >If you used Apple Pay or Google Pay, enter the last 4 digits of the number shown under card
                            details in your wallet app.</span
                        >
                    </ce-form-field>
                </div>
            </fieldset>

            <!-- Submit Button -->
            <div class="LandingPage-button-container">
                <button ce-button-large ce-button-type-tertiary [disabled]="isLoading || receiptForm.invalid">
                    @if (!isLoading) {
                        <div class="flex-row flex-middle flex-center">
                            <span>Search receipt</span>
                            <ce-icon [svgIcon]="'search'" suffix-icon />
                        </div>
                    } @else {
                        <div class="flex flex-center">
                            <ce-spinning-loader />
                        </div>
                    }
                </button>
                <div id="aws-waf-captcha" class="Captcha" style="display: none"></div>
            </div>
        </form>
    </div>
</div>
